import React from "react";
import {
	List,
	Datagrid,
	TextField,
	ReferenceField,
	EditButton,
	ShowButton,
	ChipField,
	Filter,
	TextInput,
	ReferenceArrayInput,
	SelectArrayInput,
	DateField
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from "../Actions";

const BillFilter = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
	return (
		<Filter {...props}>
			{/* <TextInput source="name_contains" /> */}
			<ReferenceArrayInput
				alwaysOn
				style={{ minWidth: "200px" }}
				source="project"
				reference="project"
				filter={filter}
			>
				<SelectArrayInput optionText="name" />
			</ReferenceArrayInput>
		</Filter>
	);
};

export const BillTypeList = props => {
	const role = localStorage.getItem("role");
	const project = JSON.parse(localStorage.getItem("project"));
	const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
	return (
		<List
			{...props}
			title="bill.bill"
			bulkActions={false}
			actions={<Actions create />}
			filters={<BillFilter />}
			filterDefaultValues={filter}
		>
			<Datagrid>
				<div />
				<TextField source="name" />
				<TextField source="key" />
				<ReferenceField source="project" reference="project" linkType={false}>
					<ChipField source="name" />
				</ReferenceField>
				{/* <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <ReferenceField linkType={false} source="room" reference="room">
          <TextField source="name" />
        </ReferenceField>
        <DateField source="date" locales="th-TH" options={{ year: 'numeric', month: 'long' }} /> */}
				<EditButton />
			</Datagrid>
		</List>
	);
};



// WEBPACK FOOTER //
// ./src/components/billtype/BillTypeList.js